import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

const initialState: Toolkit.Store.Toolkit.Data.JobQuotes.State = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Toolkit/Data/JobQuotes/FailedToLoadJobQuote": (
        draft: Draft<Toolkit.Store.Toolkit.Data.JobQuotes.State>,
        action: { jobQuoteId: string; status: number },
    ) => {
        delete draft.isLoading[action.jobQuoteId];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.jobQuoteId] = action.status;
        }
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type ToolkitJobQuotesActions = Parameters<typeof reducer>[1];
export default reducer;
